import clsx from 'clsx';
import Depot from '../_shared/depot';
import * as styles from './style.module.css';
const Spinner = ({ inverted = false, size = 24, className, ...commonProps }) => {
    const classes = clsx(styles.root, inverted && styles.inverted, size === 48 && styles.large, className);
    return Depot.createElement('div', {
        ...commonProps,
        className: classes,
    });
};
export default Spinner;
//# sourceMappingURL=index.js.map